import { sendGet, sendPost, sendPut } from './axios';

// eslint-disable-next-line import/prefer-default-export
export const loadProfile = () => sendGet('/idol/profile');
export const updateProfile = (payload: any) => sendPut('/idol/profile/update', payload);
export const settingBeautyFilter = (payload: any) => sendPost('/idol/filter', payload);
